import { Link } from "react-router-dom";
import menu from "../asset/menu.svg";
import wave from "../asset/wave.gif";
export default function Header(props) {
  return (
    <div>
      <div className="flex w-full p-5 justify-between">
        <Link to="/">
          <h1 className="bold break-all tracking-tighter antialiased text-3xl px-7 text-black-200 pointer-events-auto">
            Cool Storm
          </h1>
        </Link>
        <div className="float-right py-3 px-7">
          <Link to="/contact">
            <div className="logo break-all tracking-tighter antialiased text-xl text-black-200">
              {props.something.length ? (
                <img
                  src={wave}
                  alt=""
                  className="ml-auto object-scale-down h-10 pointer-events-none"
                ></img>
              ) : (
                <h1 className="pointer-events-auto">Say Hi</h1>
              )}
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
